const micList = {
  bet: ['XBUD', 'XBU2', 'BETA', 'XTND'],
  xetraFr: ['XETR', 'XFRA', 'XWBO'],
  xetraVie: ['XWBO'],
  london: ['XLON'],
  usa: [
    'AATS',
    'ADVT',
    'ARKX',
    'ARCX',
    'ASEF',
    'BAML',
    'BAMX',
    'BARX',
    'BBSF',
    'BGCF',
    'BHSF',
    'BIDS',
    'BKKT',
    'BLUE',
    'BNDS',
    'BNPC',
    'BNPH',
    'BNYC',
    'BPOL',
    'BSTX',
    'BTEC',
    'BTNL',
    'CALH',
    'CAST',
    'CCMX',
    'CDED',
    'CFIM',
    'CGMI',
    'CGXS',
    'CLST',
    'CMSF',
    'CODA',
    'COHR',
    'CPGX',
    'CRED',
    'DASH',
    'DBAB',
    'DEAL',
    'DWFI',
    'EDXM',
    'EGMT',
    'EQUS',
    'FAST',
    'FICO',
    'FINR',
    'FREX',
    'FSEF',
    'FTUS',
    'FXAL',
    'FXCM',
    'G1XX',
    'GFAM',
    'GLLC',
    'GLMX',
    'GLPS',
    'GLPX',
    'GOTC',
    'GOVX',
    'GREE',
    'GSCO',
    'GSEF',
    'GTCO',
    'GTSX',
    'HEGX',
    'HPPO',
    'HRTF',
    'HRTX',
    'HSFX',
    'IBKR',
    'ICEL',
    'IDXM',
    'IEXG',
    'IFUS',
    'IMCS',
    'INCR',
    'INTL',
    'ISDA',
    'ITGI',
    'JLQD',
    'JNST',
    'JPBX',
    'JPMS',
    'JPMX',
    'JSES',
    'JSJX',
    'KLSH',
    'KNIG',
    'LAMP',
    'LASF',
    'LEDG',
    'LESI',
    'LEVL',
    'LIUS',
    'LPSF',
    'LQED',
    'LTAA',
    'LTSE',
    'MEMX',
    'MIHI',
    'MSCO',
    'MTXX',
    'NBLX',
    'NFSC',
    'NMRA',
    'NODX',
    'NPMS',
    'NXUS',
    'NYPC',
    'OCEA',
    'OCTL',
    'OLLC',
    'OPRA',
    'OTCI',
    'OTCM',
    'OTCN',
    'PIPE',
    'PIPR',
    'PRSE',
    'PUMA',
    'PUND',
    'RAJA',
    'RCMA',
    'RTXF',
    'SAGE',
    'SCXO',
    'SFOX',
    'SGAS',
    'SGMA',
    'SHAW',
    'SMFE',
    'SOHO',
    'SPAX',
    'SPTX',
    'SSTX',
    'STFX',
    'STRM',
    'SUNT',
    'TERA',
    'TFSU',
    'THEM',
    'THRE',
    'TMID',
    'TPSE',
    'TRAI',
    'TRCK',
    'TRCX',
    'TRUX',
    'TRWB',
    'TSAD',
    'TSEF',
    'U360',
    'UBEC',
    'UBSA',
    'UBSS',
    'VERT',
    'VFCM',
    'VIRT',
    'VUSA',
    'WELS',
    'WSAG',
    'XAQS',
    'XBOX',
    'XCBO',
    'XCBT',
    'XCFF',
    'XCME',
    'XCUR',
    'XELX',
    'XGMX',
    'XINS',
    'XISX',
    'XMER',
    'XMGE',
    'XNAS',
    'XNYM',
    'XNYS',
    'XPUS',
    'XTRD',
    'XTXD',
    'YKNA',
  ],
};

const betMarketCodes = new Set(micList.bet);
const xetraFrMarketCodes = new Set(micList.xetraFr);
const usaMarketCodes = new Set(micList.usa);

export { betMarketCodes, usaMarketCodes, xetraFrMarketCodes };
